import { render, staticRenderFns } from "./Postcode.vue?vue&type=template&id=2d658ec7&"
import script from "./Postcode.vue?vue&type=script&lang=js&"
export * from "./Postcode.vue?vue&type=script&lang=js&"
import style0 from "./Postcode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports